import app from 'app-entrypoint';

if (typeof app === 'function') {
  app();
}



//////////////////
// WEBPACK FOOTER
// /Users/chrisessig/Documents/tribune/github/redistricting-CD27/config/entry.js
// module id = null
// module chunks = 